/**
 * A simple helper class to facilitate managing a single subscription to a redux store.
 * This class was inspired by the react-redux Subscription class.
 */
export default class Subscription {
    constructor(store, onStateChange) {
        this.store = store;
        this.onStateChange = onStateChange;
        this.unsubscribe = null;
    }
    trySubscribe() {
        if (!this.unsubscribe) {
            this.unsubscribe = this.store.subscribe(this.onStateChange);
        }
    }
    tryUnsubscribe() {
        if (this.unsubscribe) {
            this.unsubscribe();
            this.unsubscribe = null;
        }
    }
}
